import { StateType } from 'data/types'

import auth from '../../Auth/selectors'
import balance from '../../Balance/selectors'
import instrument from '../../Instrument/selectors'
import payments from '../../Payments/selectors'

const getCurrencyDefinition = (state: StateType) => (currency: string) => {
  const currencies = instrument.getCurrenciesIndexed(state)
  return currencies[currency]
}

const getBalance = (state: StateType) => (currency: string) => {
  const balances = balance.getAll(state)
  const currentCurrencyDefinition = getCurrencyDefinition(state)(currency)
  const localCurrency = auth.getLocalCurrency(state)
  return balance.filterByCurrency(
    balances,
    currentCurrencyDefinition || {
      blocked: false,
      fiat: true,
      key: localCurrency,
      name: ''
    }
  )
}

const getState = (state: StateType) => state.withdrawal

const getSubmittedOrder = (state: StateType) => getState(state).response
const isSubmitting = (state: StateType) => getState(state).isSubmitting

const getWalletAddress = (state: StateType) => (currency: string) => {
  const user = auth.getUser(state)
  if (user && user.walletAddresses) {
    return user.walletAddresses[currency]
  }
}

const getCryptoBeneficiaryId = (state: StateType) => (currency: string) => {
  const addresses = payments.getWhitelistAddresses(state)
  return addresses.find((add) => add.currency === currency)?.id
}

export default {
  getBalance,
  getCryptoBeneficiaryId,
  getSubmittedOrder,
  getWalletAddress,
  isSubmitting
}
